export const toØre = (amount: number) => Math.round(amount * 100);

export const fromØre = (amount: number) => +(amount / 100).toFixed(2);
